import type {AiPromptBoxAttachments} from '@Components/ai-prompt-box/components/ai-prompt-box-attachments/ai-prompt-box-attachments.types';
import type {ChangeStyleTheme, RequestConfig, TextPartPurpose} from '@Components/ai-chat-window/ai-chat-window.types';

export const CHANGE_STYLE_DROPDOWN_MODAL_PANEL_ID = 'change-style-dropdown-modal-panel-id';

export interface ChangeStyleThemeOption {
  theme: ChangeStyleTheme;
  label: string;
  imageUrl: string;
}

export interface ChangeStyleDropdownProps {
  chatId: string;
  onGenerate: (prompt: string, promptAttachments?: AiPromptBoxAttachments, requestConfig?: RequestConfig, purpose?: TextPartPurpose) => Promise<void>;
  imageHashedId: string;
  canWrite: boolean;
  imageWidth?: number;
  imageHeight?: number;
}
